<template lang="pug">
  div
    Divider
    v-list-item(:href="assetBundle.url(file.name)", target="_blank")
      v-list-item-icon.mr-4: v-icon mdi-file
      v-list-item-content
        v-list-item-title {{name}}
      v-list-item-action: v-icon mdi-download
    Divider

    .py-2

    Divider
    v-list-item(dense)
      v-list-item-content: v-list-item-title Size
      v-list-item-action: v-list-item-action-text {{assetBundle.size(file.size)}}
    Divider(inset=16)
    v-list-item(dense)
      v-list-item-content: v-list-item-title Encrypted
      v-list-item-action: v-list-item-action-text {{file.isEncrypt}}
    template(v-if="false")
      Divider(inset=16)
      v-list-item(dense)
        v-list-item-content: v-list-item-title URL hash
        v-list-item-action: v-list-item-action-text.text-right(v-html="file.path.replace('/', '/<br>')")
      Divider(inset=16)
      v-list-item(dense)
        v-list-item-content: v-list-item-title Bucket on asset.kirafan.cn
        v-list-item-action: v-list-item-action-text.text-right(v-html="file.path[file.path.length-1]")
    Divider

    .py-2

    v-list-item(dense)
      v-list-item-content: v-list-item-title Contents
    Divider
    template(v-if="!ok")
      .pa-8.text-center
        v-progress-circular(indeterminate=true, color="primary")
    template(v-else-if="contents.length == 0")
      v-list-item(dense)
        v-list-item-content: v-list-item-subtitle No Sprites
    template(v-else, v-for="content, i in contents")
      Divider(v-if="i", inset=56)
      v-list-item(dense, :href="assetBundle.url(file.name, {name: content + '.png'})", target="_blank")
        v-list-item-avatar(tile, size=32).mr-2.my-1: v-img(contain, :src="assetBundle.url(file.name, {name: content + '.icon.jpg'})")
        v-list-item-content: v-list-item-title {{content}}
    Divider    

</template>

<script>
import axios from 'axios';
import Divider from '@/components/Divider';
import assetBundle from '@/assetBundle';

export default {
  name: 'File',

  props: ['path'],

  components: { Divider },

  data() {
    return {
      assetBundle,
      ok: false,
      contents: [],
    };
  },

  computed: {
    file() {
      return assetBundle.get(this.path);
    },

    name() {
      let paths = this.path.split('/');
      return paths[paths.length - 1];
    },

  },

  methods: {
    load() {
      const path = this.path;
      this.ok = false;
      axios.get(assetBundle.url(path, { type: 'index' })).then(response => {
        if (this.path == path) {
          this.contents = response.data.sort(String.sort);
          this.ok = true;
        }
      }).catch(() => {
        if (this.path == path) {
          this.contents = [];
          this.ok = true;
        }
      });
    }
  },

  mounted() {
    this.load();
  },

  watch: {
    path() {
      this.load();
    }
  }
};
</script>